import { useState } from "react";

/** Copies `text` to the clipboard and briefly shows confirmation. */
const CopyButton: React.FC<{ text: string; label?: string; className?: string }> = ({
  text,
  label = "Copy link",
  className = "",
}) => {
  const [copied, setCopied] = useState(false);
  return (
    <button
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(text);
          setCopied(true);
          setTimeout(() => setCopied(false), 1500);
        } catch {
          /* clipboard may be unavailable; ignore */
        }
      }}
      className={`rounded-full bg-cream-200 px-3 py-1.5 text-xs font-semibold text-ink ring-1 ring-primary-200/70 hover:bg-cream ${className}`}
    >
      {copied ? "Copied!" : label}
    </button>
  );
};

export default CopyButton;
